import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/home/Home";
import Layout from "./pages/layout/Layout";
import RequireBrand from "./components/RequireBrand";
import ProductInDetails from "./pages/productInDetails/ProductInDetails";
import GenderWishShop from "./pages/genderWishShop/GenderWishShop";
import ProductList from "./pages/productList/ProductList";
import SearchProductList from "./pages/searchProductList/SearchProductList";
import Cart from "./pages/checkout/Checkout";
import SignIn from "./pages/signIn/SignIn";
import SignUp from "./pages/signUp/SignUp";
import RequireAuthForSignInAndUp from "./components/RequireAuthForSignInAndUp";
import RequireAuthForUser from "./components/RequireAuthForUser";
import ManageAccount from "./pages/user/manageAccount/ManageAccount";
import User from "./pages/user";
import AddressBook from "./pages/user/addressBook/AddressBook";
import ManageAddress from "./pages/user/addressBook/manageAddress/ManageAddress";
import Coupon from "./pages/user/coupon/Coupon";
import Profile from "./pages/user/profile/Profile";
import Wishlist from "./pages/wishlist/Wishlist";
import Verification from "./pages/verification/Verification";
import MyOrders from "./pages/user/myOrders/MyOrders";
import MyOrderDetails from "./pages/user/myOrders/myOrderDetails/MyOrderDetails";
import ChangePhoneNo from "./pages/user/changePhoneNo/ChangePhoneNo";
import ChangePasswordAndPhoneNoVerification from "./pages/verification/ChangePasswordAndPhoneNoVerification";
import VerificationSignIn from "./pages/verification/VerificationSignIn";
import UserResetPassword from "./pages/user/userResetPassword/UserResetPassword";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Faqs from "./pages/faqs/Faqs";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import TermsAndCondition from "./pages/termsAndCondition/TermsAndCondition";
import ContactUs from "./pages/contactUs/ContactUs";
import AboutUs from "./pages/aboutUs/AboutUs";
import Error404 from "./pages/error404/Error404";
import MyLoader from "./components/myLoader/MyLoader";
import RefundAndCancellationPolicy from "./pages/refundAndCancellationPolicy/RefundAndCancellationPolicy";
import ShippingAndDeliveryPolicy from "./pages/shippingAndDeliveryPolicy/ShippingAndDeliveryPolicy";
import { useEffect } from "react";
import { initGA, logPageView } from "./analytics";
import { ENV, PIXEL_ID } from "./constant";
import ReactPixel from "react-facebook-pixel";
import OceanBay from "./pages/perfume/oceanBay/OceanBay";
import Vengeance from "./pages/perfume/vengeance/Vengeance";
import CrimsonOak from "./pages/perfume/crimsonOak/CrimsonOak";
import InnerChaos from "./pages/perfume/innerChaos/InnerChaos";
import SweetSmoke from "./pages/perfume/sweetSmoke/SweetSmoke";
import NewHome from "./pages/newHome/NewHome";

function App() {
  const location = useLocation();

  useEffect(() => {
    if (ENV === "production") {
      initGA();
      ReactPixel.init(PIXEL_ID, {
        autoConfig: true,
        debug: false, // set to true for debugging
      });
      ReactPixel.pageView();
    }
  }, []);

  useEffect(() => {
    if (ENV === "production") {
      logPageView(location.pathname + location.search);
      ReactPixel.pageView();
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/">
        <Route
          element={
            <RequireBrand>
              <Layout />
            </RequireBrand>
          }
        >
          {/* <Route index element={<Home />} /> */}
          <Route index element={<NewHome />} />
          {/* <Route path="new" element={<NewHome />} /> */}
          <Route path="shop">
            <Route path=":gender">
              <Route index element={<GenderWishShop />} />
              <Route path=":categoryName/:id" element={<ProductList />} />
            </Route>
            <Route
              path="category/:categoryID/:categoryName/"
              element={<SearchProductList />}
            />
          </Route>
          <Route path="perfume">
            <Route
              path="ocean-bay/68cc5b00b366285697596625/details"
              element={<OceanBay />}
            />
            <Route
              path="vengeance/68cc5c04b366285697596669/details"
              element={<Vengeance />}
            />
            <Route
              path="crimson-oak/68cc5913b3662856975965d7/details"
              element={<CrimsonOak />}
            />
            <Route
              path="inner-chaos/68cc5a19b366285697596614/details"
              element={<InnerChaos />}
            />
            <Route
              path="sweet-smoke/68cc5b8db366285697596662/details"
              element={<SweetSmoke />}
            />
          </Route>
          <Route
            path=":gender/:productCategory/:productName/:id/details"
            element={<ProductInDetails />}
          />
          <Route
            path=":productCategory/:productName/:id/details"
            element={<ProductInDetails />}
          />
          <Route
            path="search/:searchID/:search"
            element={<SearchProductList />}
          />
          <Route path="checkout" element={<Cart />} />
          <Route
            path="wishlist"
            element={
              <RequireAuthForUser>
                <Wishlist />
              </RequireAuthForUser>
            }
          />
          <Route path="user">
            <Route
              element={
                <RequireAuthForUser>
                  <User />
                </RequireAuthForUser>
              }
            >
              <Route index element={<Profile />} />
              <Route path="manage-account" element={<ManageAccount />} />
              <Route path="address">
                <Route index element={<AddressBook />} />
                <Route path="new" element={<ManageAddress />} />
                <Route path=":id/edit" element={<ManageAddress />} />
              </Route>
              <Route path="coupon" element={<Coupon />} />
              <Route path="my-orders">
                <Route index element={<MyOrders />} />
                <Route
                  path=":id/:productName/details"
                  element={<MyOrderDetails />}
                />
              </Route>
              <Route
                path="reset-password"
                element={
                  <UserResetPassword
                    oldPassword={false}
                    title="Reset Password?"
                    description="If you want to chang your old password to new password."
                  />
                }
              />
              <Route
                path="forgot-password"
                element={
                  <UserResetPassword
                    oldPassword={true}
                    title="Forgot Password?"
                    description="You don't remember your password then reset your password."
                  />
                }
              />
            </Route>
          </Route>
          <Route path="faqs" element={<Faqs />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="refund-and-cancellation-policy"
            element={<RefundAndCancellationPolicy />}
          />
          <Route
            path="shipping-and-delivery-policy"
            element={<ShippingAndDeliveryPolicy />}
          />
          <Route path="terms-and-conditions" element={<TermsAndCondition />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="about-us" element={<AboutUs />} />
        </Route>
        <Route
          path="change-phone-no"
          element={
            <RequireBrand>
              <RequireAuthForUser>
                <ChangePhoneNo />
              </RequireAuthForUser>
            </RequireBrand>
          }
        />
        <Route
          path="verification/:title"
          element={
            <RequireBrand>
              <ChangePasswordAndPhoneNoVerification />
            </RequireBrand>
          }
        />
        <Route
          path="reset-password"
          element={
            <RequireBrand>
              <ResetPassword />
            </RequireBrand>
          }
        />
        <Route
          path="sign-in"
          element={
            <RequireBrand>
              <RequireAuthForSignInAndUp>
                <SignIn />
              </RequireAuthForSignInAndUp>
            </RequireBrand>
          }
        />
        <Route
          path="forgot-password"
          element={
            <RequireBrand>
              <UserResetPassword
                oldPassword={true}
                title="Forgot Password"
                description="You don't remember your password then reset your password."
              />
            </RequireBrand>
          }
        />
        <Route
          path="sign-up"
          element={
            <RequireBrand>
              <RequireAuthForSignInAndUp>
                <SignUp />
              </RequireAuthForSignInAndUp>
            </RequireBrand>
          }
        />
        <Route
          path="verification"
          element={
            <RequireBrand>
              <RequireAuthForSignInAndUp>
                <Verification />
              </RequireAuthForSignInAndUp>
            </RequireBrand>
          }
        />
        <Route
          path="verification/sign-in"
          element={
            <RequireBrand>
              <RequireAuthForSignInAndUp>
                <VerificationSignIn />
              </RequireAuthForSignInAndUp>
            </RequireBrand>
          }
        />
        <Route
          path=":gender/:productCategory/:productName/:id/error404"
          element={
            <RequireBrand>
              <Error404 />
            </RequireBrand>
          }
        />
        <Route
          path=":productCategory/:productName/:id/error404"
          element={
            <RequireBrand>
              <Error404 />
            </RequireBrand>
          }
        />
        <Route path="my-loader" element={<MyLoader height="100vh" />} />
      </Route>
    </Routes>
  );
}

export default App;
